export const reduceObject = (keys, data, keyFormat) =>
  keys.reduce((acc, key) => {
    const keyName = keyFormat ? keyFormat.replace('{}', key) : key
    return data.hasOwnProperty(keyName)
      ? {
          ...acc,
          [key]: data[keyName]
        }
      : acc
  }, {})
